import 'babel-core/polyfill';
import ReactDOM from 'react-dom';
import configureStore from '../configureStore';
import { createRootReducer } from '../reducers/';
import createRootRouter from '../createRootRouter';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-select/dist/react-select.css';
import 'font-awesome/css/font-awesome.css';
import 'stylesheets/basic.css';
import 'stylesheets/layout.css';
import tubeRouter from '../screens/Tube/router';
import tubeReducer from '../screens/Tube/reducers/';
import { url } from 'configs/';
import { locationOrigin } from 'utils/';
if (!window.Intl) {
  require('intl');
}
if (!window.location.origin) {
  locationOrigin();
}

const reducer = createRootReducer('tube', tubeReducer);
const store = configureStore(reducer, 'Tube', url.NEWTUBE_API_SERVER);
const rootRouter = createRootRouter(store, tubeRouter);

ReactDOM.render(rootRouter, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/entrys/tubeEntry.js
 **/